export const PARAMS = {
  backend_url: 'https://photo.arbat07.ru/client/api/',
  // backend_url: 'http://localhost:3010/',
};
